<template>
    <div>
        <component
            :is="`section-${item.type}`"
            v-for="(item, index) in value"
            :key="index"
            :value="item"
        />
    </div>
</template>

<script>
import LongText from './sections/LongText';
import ShortSection from './sections/ShortSection';
import Checkbox from './sections/Checkbox';
import MultipleSelect from './sections/MultipleSelect';
import File from './sections/File';

export default {
    components: {
        'section-short': ShortSection,
        'section-long': LongText,
        'section-number': ShortSection,
        'section-wysiwyg': LongText,
        'section-email': ShortSection,
        'section-checkbox': Checkbox,
        'section-dropdown': ShortSection,
        'section-multiSelect': MultipleSelect,
        'section-file': File
    },

    props: {
        value: {
            type: Array,
            required: true
        }
    }
};
</script>
